export default __webpack_public_path__ + "static/media/rotateCounterClockwise.18bc366c.svg";